import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ScoreIndicator extends Component {
    render() {

        function rgbToHex(r, g, b) {
            return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1, 7);
        }

        function interpolate(c1, c2, value) {
            const percent = value / 100;
            let resultRed = c1.red + percent * (c2.red - c1.red);
            let resultGreen = c1.green + percent * (c2.green - c1.green);
            let resultBlue = c1.blue + percent * (c2.blue - c1.blue);

            return rgbToHex(resultRed, resultGreen, resultBlue);
        }

        const red = {
            red: 217,
            green: 83,
            blue: 79
        };

        const yellow = {
            red: 255,
            green: 213,
            blue: 0
        };

        const green = {
            red: 92,
            green: 184,
            blue: 92
        };

        const {size, strokeWidth, margin, style, value} = this.props;

        const width = size || 75;
        const stroke = strokeWidth || 4;

        // Center of circle
        const cx = width / 2;
        const cy = width / 2;

        const radius = cx - (stroke - 2);
        const viewBox = "0 0 " + width + " " + width;
        const dasharray = 2 * 3.1415926 * radius;
        const deg = 90;
        const rotate = "rotate(-" + deg + "deg)";
        const textRotate = "rotate(90 " + cx + " " + cx + ")";
        const adjDash = dasharray * (1 - (value / 100));

        const color = value < 50 ? interpolate(red, yellow, value * 2) : interpolate(yellow, green, (value - 50) * 2);
        return (
            <div className="score-indicator" style={{margin: margin || '0 1rem', ...style}}>
                <svg style={{transform: rotate}} width={width} height={width} viewBox={viewBox}>
                    <circle cx={cx} cy={cy} r={radius} fill="none" stroke="#e6e6e6" strokeWidth={stroke}/>

                    <circle className="score-indicator-progress__value"
                            style={{stroke: color}}
                            cx={cx} cy={cy} r={radius}
                            fill="none"
                            stroke={color}
                            strokeWidth={stroke}
                            strokeDasharray={dasharray} strokeDashoffset={adjDash}/>

                    <text x="50%" y="50%"
                          textAnchor="middle"
                          fill={color}
                          transform={textRotate}
                          fontSize="2rem"
                          strokeWidth="1px"
                          stroke={color}
                          fontFamily="proxima-nova"
                          dy=".3em">
                        {value}
                    </text>
                </svg>
            </div>
        );
    }
}

ScoreIndicator.propTypes = {
    size: PropTypes.number,
    strokeWidth: PropTypes.number,
    margin: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.number.isRequired
};

export default ScoreIndicator;


// WEBPACK FOOTER //
// ./src/components/display/ScoreIndicator.js